import {LeagueId, Team} from '@/model/core/core-data.model';
import {IndexedTeam, IndexedTeams} from '@/model/site/state.model';
import {get, HttpResponse} from '@/services/http';
import {log} from '@/utils/logger';
import teamData from '@/assets/static/teams.json';

const BASE_URL = import.meta.env.VUE_APP_API_ROOT + '/teams';

const teams: Record<string, IndexedTeams> = teamData;

const TEAM_SERVICE = {
	teams: async function (seasonId: string, leagueId: LeagueId): Promise<IndexedTeam> {
		if (teams[seasonId] && teams[seasonId][leagueId]) {
			return teams[seasonId][leagueId];
		}
		log.warn(`No teams found in ${seasonId} for league ${leagueId}, using API as fallback!`);
		return get<IndexedTeam>(`${BASE_URL}/season/${seasonId}/league/${leagueId}`).then(r => r.data);
	},
	teamById: function (teamId: string, seasonId: string, leagueId?: string): Promise<HttpResponse<Team>> {
		if (leagueId && teams[seasonId] && teams[seasonId][leagueId] && teams[seasonId][leagueId][teamId]) {
			return Promise.resolve({data: teams[seasonId][leagueId][teamId], status: 200});
		}
		log.warn(`Team ${teamId} in ${seasonId} for league ${leagueId} not found, using API as fallback!`);
		return get<Team>(`${BASE_URL}/${teamId}`, {params: {seasonId}});
	},
};

export default TEAM_SERVICE;
